import { useScreenSize } from '@ltvco/refresh-lib/utils';
import {
  useSession,
  JoinButton,
  ReactivateHeader,
} from '@ltvco/refresh-lib/v1';
import { NotificationDropdown } from '@ltvco/refresh-lib/v2';
import { useCallback, useState, type MouseEvent } from 'react';

import { MobileHeaderNav } from 'components/MobileHeaderNav/MobileHeaderNav';

import { DesktopHeaderNav } from './DesktopHeaderNav/DesktopHeaderNav';

interface ClassicHeaderContentsProps {
  handleLogout: () => void;
}

export const ClassicHeaderContents = ({
  handleLogout,
}: ClassicHeaderContentsProps) => {
  const {
    session: { isAuthenticated },
  } = useSession();
  const { isTablet } = useScreenSize();
  const [notificationDropdownAnchorEl, setNotificationDropdownAnchorEl] =
    useState<null | HTMLElement>(null);
  const [unreadNotificationCount, setUnreadNotificationCount] = useState(0);
  const openNotifications = Boolean(notificationDropdownAnchorEl);

  const isInReactivationRoute =
    window.location.pathname.includes('/reactivation');

  const handleCloseNotificationDropdown = useCallback(() => {
    setNotificationDropdownAnchorEl(null);
  }, []);

  const handleNotificationBellClick = useCallback(
    (event: MouseEvent<HTMLButtonElement>) => {
      setNotificationDropdownAnchorEl(event.currentTarget);
    },
    [],
  );

  if (!isAuthenticated) {
    return <JoinButton />;
  }
  if (isInReactivationRoute) {
    return <ReactivateHeader handleLogout={handleLogout} />;
  }
  return (
    <>
      {isTablet ? (
        <MobileHeaderNav
          handleLogout={handleLogout}
          handleNotificationBellClick={handleNotificationBellClick}
          unreadNotificationCount={unreadNotificationCount}
        />
      ) : (
        <DesktopHeaderNav
          handleNotificationBellClick={handleNotificationBellClick}
          unreadNotificationCount={unreadNotificationCount}
        />
      )}

      <NotificationDropdown
        anchorEl={notificationDropdownAnchorEl}
        open={openNotifications}
        handleClose={handleCloseNotificationDropdown}
        setUnreadNotificationCount={setUnreadNotificationCount}
      />
    </>
  );
};
